var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAudit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.449,
    height: 53.944,
    viewBox: "0 0 57.449 53.944",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "audit",
    transform: "translate(-9.5 -16.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9816",
    "data-name": "Group 9816",
    transform: "translate(10 17.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6477",
    "data-name": "Path 6477",
    d: "M142.481,132.2l-6.987-6.987c1.621-2.742,2.671-5.031,2.671-8.227a13.783,13.783,0,1,0-27.565,0c0,7.607,6.2,14.522,13.783,13.783,3.1-.31,5.89-.858,8.227-2.671l6.987,6.987a2.067,2.067,0,0,0,2.885-2.885Zm-27.827-15.213a9.753,9.753,0,1,1,9.753,9.753,9.749,9.749,0,0,1-9.753-9.753Z",
    transform: "translate(-86.612 -82.717)",
    fill: "#03426b",
    stroke: "#f8f8f8",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6478",
    "data-name": "Path 6478",
    d: "M52.85,21.95A4.656,4.656,0,0,0,48.2,17.3H14.65A4.671,4.671,0,0,0,10,21.95V65.42a4.656,4.656,0,0,0,4.65,4.65h3.386l.024-.024a1.928,1.928,0,0,0,.382.024H35.109a2.027,2.027,0,1,0,0-4.054H16.391A2.315,2.315,0,0,1,14.078,63.7V23.691a2.315,2.315,0,0,1,2.313-2.313H46.483A2.315,2.315,0,0,1,48.8,23.691v8.2h0a2.027,2.027,0,1,0,4.054,0h0V21.95Z",
    transform: "translate(-10 -17.3)",
    fill: "#03426b",
    stroke: "#f8f8f8",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6479",
    "data-name": "Path 6479",
    d: "M42.8,63.627a2.025,2.025,0,0,0,2.027,2.027h23.2a2.025,2.025,0,0,0,2.027-2.027h0A2.025,2.025,0,0,0,68.028,61.6h-23.2A2.041,2.041,0,0,0,42.8,63.627Z",
    transform: "translate(-34.979 -51.037)",
    fill: "#03426b",
    stroke: "#f8f8f8",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6480",
    "data-name": "Path 6480",
    d: "M42.8,115.227a2.025,2.025,0,0,0,2.027,2.027H56.153a2.025,2.025,0,0,0,2.027-2.027h0a2.025,2.025,0,0,0-2.027-2.027H44.827a2.041,2.041,0,0,0-2.027,2.027Z",
    transform: "translate(-34.979 -90.332)",
    fill: "#03426b",
    stroke: "#f8f8f8",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6481",
    "data-name": "Path 6481",
    d: "M42.8,165.427a2.025,2.025,0,0,0,2.027,2.027h7.344a2.025,2.025,0,0,0,2.027-2.027h0a2.025,2.025,0,0,0-2.027-2.027H44.827a2.041,2.041,0,0,0-2.027,2.027Z",
    transform: "translate(-34.979 -128.562)",
    fill: "#03426b",
    stroke: "#f8f8f8",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudit);
export default __webpack_public_path__ + "static/media/audit.b1ec10ea5c588f82454f00a134074506.svg";
export { ForwardRef as ReactComponent };